import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import CharacterSpine, { CharacterAnimation } from '../CharacterSpine';
import { EquipmentType } from '../VehicleEquipment';
import { VehicleEquipmentMeleeWeapon } from '../VehicleEquipmentMeleeWeapon';
import { VehicleVillain } from './../VehicleVillain';

export class VehicleWeaponGlove extends VehicleEquipmentMeleeWeapon {
  constructor(scene: Phaser.Scene, vehicle: VehicleVillain, camera: Phaser.Cameras.Scene2D.Camera, spine: CharacterSpine) {
    super(scene, EquipmentType.GiantMallet, vehicle, camera, spine, 'weapon', CharacterAnimation.Weapon);
  }

  public fire(): void {
    app.audioHandler.playSound(this.scene, Sounds.Track.PrankPreFire1, Sounds.Channel.SFX, { volume: 1.0 });
    this.vehicle.CharacterSpine.fireEquipment();
  }

  public onFinishedFiring() {
    this.emit(VehicleWeaponGlove.events.FinishedFiring);
  }

  public onHit(): void {
    app.audioHandler.playSound(this.scene, Sounds.Track.PrankPunch1, Sounds.Channel.SFX, { volume: 1.0 });
  }

  protected onFire() {
    this.emit(VehicleWeaponGlove.events.Firing);
  }

  protected override animationStart(entry: spine.TrackEntry) {
    if (entry.animation.name == CharacterAnimation.Weapon) {
      this.onFire();
    }

    super.animationStart(entry);
  }

  protected override animationEnd(entry: spine.TrackEntry) {
    if (entry.animation.name == CharacterAnimation.Weapon) {
      this.onFinishedFiring();
    }

    super.animationEnd(entry);
  }
}
